<script setup lang="ts">
defineOptions({
	name: 'HowLongSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-material-symbols:alarm-on-outline-rounded"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('How long can cookies be stored') }}?
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>{{ $t('In terms of duration, cookies can be classified as follows') }}:</p>

			<p>{{ $t('Session cookies: These cookies remain valid until the browser is closed or the session ends') }}.</p>

			<p>
				{{
					$t(
						'Persistent cookies: These cookies are stored for longer periods, and thus require action on the part of the user to delete them. Gaveta Decimal does not store cookies with a duration exceeding two years',
					)
				}}.
			</p>

			<p>
				{{ $t('For further information regarding the duration of each cookie, please consult the following link') }}.
			</p>
		</div>
	</section>
</template>
